module.exports = __webpack_public_path__ + "static/img/service.c154ece9.png";